import React from "react";
import { useSelected, useFocused } from "slate-react";
import "./ImageElement.css";

export const ImageElement = ({ attributes, children, element }) => {
  const { url } = element || {};
  const selected = useSelected();
  const focused = useFocused();

  const containerClass = `image-container ${selected && focused ? "focused" : ""}`;
  const frameClass = `image-frame ${selected && focused ? "image-frame--active" : ""}`;

  return (
    <div {...attributes} className={containerClass}>
      <div
        contentEditable={false}
        className={frameClass}
      >
        {url ? (
          <img
            src={url}
            alt="Embedded"
            className="image-content"
            loading="lazy"
            decoding="async"
          />
        ) : (
          <div className="placeholder">圖片加載失敗</div>
        )}
      </div>
      {children}
    </div>
  );
};
